import { render } from "./grading-test-introduce.vue?vue&type=template&id=8a93e020"
import script from "./grading-test-introduce.vue?vue&type=script&lang=js"
export * from "./grading-test-introduce.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__